// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__26mFi","addWidgetButton":"Header_addWidgetButton__1kZ__","dashboardTabs":"Header_dashboardTabs__1-aMA","active":"Header_active__Bb2x7"};